module.exports = __webpack_public_path__ + "static/img/logo-2.453233b.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo-2.png
// module id = MNlN
// module chunks = 7